export const URL_API = "https://apichatbot.saturnoconsulting.com/api/v1/";
export const URL_API_EBE = "https://ebe.saturnoconsulting.com/ebe-api/v1.0/"; //"http://57.129.5.30:5002/ebe-api/v1.0/";
